import { createContext, useContext, useEffect, useState } from "react";
import { copy } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rn_lang") || "ar");
  const rtl = lang === "ar";

  useEffect(() => {
    localStorage.setItem("rn_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? "rtl" : "ltr";
  }, [lang, rtl]);

  const toggle = () => setLang((l) => (l === "ar" ? "en" : "ar"));
  return <LanguageContext.Provider value={{ lang, rtl, t: copy[lang], toggle }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
